import React from "react";
import { Modal } from "antd";

const SaleTypeModal = ({
  saleTypeModalOpen,
  setSaleTypeModalOpen,
  saleTypeModalItem,
  cart,
  setCart,
}) => {
  return (
    <Modal
      open={saleTypeModalOpen}
      onCancel={() => setSaleTypeModalOpen(false)}
      footer={null}
      centered
      closable={true}
      maskClosable={true}
      width={420}
      styles={{ body: {
        height: "380px",
        padding: "20px",
        background: "#ffffff",
      } }}
      className="production-center-modal"
      title={
        <div
          style={{
            fontSize: "1.25rem",
            fontWeight: 600,
            color: "#0F0718",
            marginBottom: "16px",
          }}
        >
          Order Type
        </div>
      }
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "12px",
        }}
      >
        <div
          onClick={() => {
            const updatedItems = cart.items.map((i) => (i.lineId === saleTypeModalItem.lineId ? { ...i, saleType: "DI" } : i));
            setCart({ ...cart, items: updatedItems });
            setSaleTypeModalOpen(false);
          }}
          style={{
            border: saleTypeModalItem?.saleType === "DI" ? "2px solid #f3f4f9" : "1px solid #d9d9d9",
            background: saleTypeModalItem?.saleType === "DI" ? "#9fa4ae" : "#ffffff",
            padding: "16px 0",
            borderRadius: "12px",
            textAlign: "center",
            fontSize: "1rem",
            fontWeight: 500,
            color: "#0F0718",
            cursor: "pointer",
            transition: "all 0.2s",
          }}
        >
          Dine In
        </div>

        <div
          onClick={() => {
            const updatedItems = cart.items.map((i) => (i.lineId === saleTypeModalItem.lineId ? { ...i, saleType: "TA" } : i));
            setCart({ ...cart, items: updatedItems });
            setSaleTypeModalOpen(false);
          }}
          style={{
            border: saleTypeModalItem?.saleType === "TA" ? "2px solid #f3f4f9" : "1px solid #d9d9d9",
            background: saleTypeModalItem?.saleType === "TA" ? "#9fa4ae" : "#ffffff",
            padding: "16px 0",
            borderRadius: "12px",
            textAlign: "center",
            fontSize: "1rem",
            fontWeight: 500,
            color: "#0F0718",
            cursor: "pointer",
            transition: "all 0.2s",
          }}
        >
          Take Away
        </div>
      </div>
    </Modal>
  );
};

export default SaleTypeModal;
